export const US_STATES = [
  { code: 'AL', name: 'Alabama', taxRate: 0.05 },
  { code: 'AK', name: 'Alaska', taxRate: 0 },
  { code: 'AZ', name: 'Arizona', taxRate: 0.045 },
  { code: 'AR', name: 'Arkansas', taxRate: 0.055 },
  { code: 'CA', name: 'California', taxRate: 0.093 },
  { code: 'CO', name: 'Colorado', taxRate: 0.0455 },
  { code: 'CT', name: 'Connecticut', taxRate: 0.0699 },
  { code: 'DE', name: 'Delaware', taxRate: 0.066 },
  { code: 'FL', name: 'Florida', taxRate: 0 },
  { code: 'GA', name: 'Georgia', taxRate: 0.0575 },
  { code: 'HI', name: 'Hawaii', taxRate: 0.11 },
  { code: 'ID', name: 'Idaho', taxRate: 0.06 },
  { code: 'IL', name: 'Illinois', taxRate: 0.0495 },
  { code: 'IN', name: 'Indiana', taxRate: 0.0323 },
  { code: 'IA', name: 'Iowa', taxRate: 0.06 },
  { code: 'KS', name: 'Kansas', taxRate: 0.057 },
  { code: 'KY', name: 'Kentucky', taxRate: 0.05 },
  { code: 'LA', name: 'Louisiana', taxRate: 0.0425 },
  { code: 'ME', name: 'Maine', taxRate: 0.0715 },
  { code: 'MD', name: 'Maryland', taxRate: 0.0575 },
  { code: 'MA', name: 'Massachusetts', taxRate: 0.05 },
  { code: 'MI', name: 'Michigan', taxRate: 0.0425 },
  { code: 'MN', name: 'Minnesota', taxRate: 0.0985 },
  { code: 'MS', name: 'Mississippi', taxRate: 0.05 },
  { code: 'MO', name: 'Missouri', taxRate: 0.054 },
  { code: 'MT', name: 'Montana', taxRate: 0.0675 },
  { code: 'NE', name: 'Nebraska', taxRate: 0.0684 },
  { code: 'NV', name: 'Nevada', taxRate: 0 },
  { code: 'NH', name: 'New Hampshire', taxRate: 0 },
  { code: 'NJ', name: 'New Jersey', taxRate: 0.1075 },
  { code: 'NM', name: 'New Mexico', taxRate: 0.059 },
  { code: 'NY', name: 'New York', taxRate: 0.1090 },
  { code: 'NC', name: 'North Carolina', taxRate: 0.0499 },
  { code: 'ND', name: 'North Dakota', taxRate: 0.029 },
  { code: 'OH', name: 'Ohio', taxRate: 0.039 },
  { code: 'OK', name: 'Oklahoma', taxRate: 0.05 },
  { code: 'OR', name: 'Oregon', taxRate: 0.099 },
  { code: 'PA', name: 'Pennsylvania', taxRate: 0.0307 },
  { code: 'RI', name: 'Rhode Island', taxRate: 0.0599 },
  { code: 'SC', name: 'South Carolina', taxRate: 0.07 },
  { code: 'SD', name: 'South Dakota', taxRate: 0 },
  { code: 'TN', name: 'Tennessee', taxRate: 0 },
  { code: 'TX', name: 'Texas', taxRate: 0 },
  { code: 'UT', name: 'Utah', taxRate: 0.0495 },
  { code: 'VT', name: 'Vermont', taxRate: 0.0875 },
  { code: 'VA', name: 'Virginia', taxRate: 0.0575 },
  { code: 'WA', name: 'Washington', taxRate: 0 },
  { code: 'WV', name: 'West Virginia', taxRate: 0.065 },
  { code: 'WI', name: 'Wisconsin', taxRate: 0.0765 },
  { code: 'WY', name: 'Wyoming', taxRate: 0 }
]

export const getStateTaxRate = (stateCode: string): number => {
  const state = US_STATES.find(s => s.code === stateCode)
  return state?.taxRate || 0
}
